<!-- //
dialog 文档预览
@auth xuyd
@date 2024-05-01
//-->
<template>
  <div class="doc-layout">
    <div class="title" style="text-align: center">{{ formData.title }}</div>
    <div class="tip mt20" style="text-align: left">
      <span>创建人：{{ formData.createUser }}</span>
      <span class="ml10">创建时间：{{ formData.createTime }}</span>
      <span class="ml10"> 最后修改人：{{ formData.updateUser }}</span>
      <span class="ml10"> 最后修改时间：{{ formData.updateTime }}</span>
    </div>
    <div v-html="formData.docContent"></div>
  </div>
</template>

<script>

export default {
  name: 'ViewDocPreview',
  data() {
    return {}
  },
  props: {
    formData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  }
}
</script>

<style lang="less" scoped>

.doc-layout {
  display: flex;
  flex-direction: column;

  .title {
    font-size: 20px;
  }

  .tip {
    font-size: 12px;
    color: #aaaaaa;
  }

}
</style>
